import { BaseModel } from 'paliari-js-utils'

const attrs = () => ({
  id: null,
  cgcm: obj => (obj ? obj : {}),
  enderecos: [],
  percentual: 0.0,
  pessoa: obj => (obj ? obj : {}),
  principal: false,
  vinculo: '',
})

export default class Socio extends BaseModel {
  constructor(obj) {
    super(attrs(), obj)
  }
}
